<!--
 * @Author: andy_chen
 * @created: 2018-11-13 15:57:46
 * 设置密码
-->

<template>
    <div class="container">
        <div v-if="hasOldPwd" class="form-item top-split-line">
            <p class="form-item-label">原密码</p>
            <label class="form-item-input">
                <input type="password" v-model="oldPwd" placeholder="请输入原密码">
            </label>
        </div>
        <div class="form-item top-split-line">
            <p v-if="hasOldPwd" class="form-item-label">新密码</p>
            <p v-else class="form-item-label">密码</p>
            <label class="form-item-input">
                <input type="password" v-model="newPwd" placeholder="密码可由6-12位的字母、数字、下划线组成">
            </label>
        </div>
        <div class="form-item ">
            <p class="form-item-label">确认密码</p>
            <label class="form-item-input">
                <input type="password" v-model="confirmPwd" placeholder="请再次确认密码">
            </label>
        </div>

        <div v-if="!this.$env.isTravelCatApp" class="cat-btn medium submit-btn" @click="handleSubmit">确定</div>
    </div>
</template>

<script>
import { setPassword, updatePassword } from "../api/user.js";
import Form from "../utils/form.js";
import nativeApi from "../nativeApi/index.js";
export default {
    name: "UpdatePassword",
    components: {},
    data() {
        return {
            oldPwd: "",
            newPwd: "",
            confirmPwd: ""
        };
    },

    created() {
        this.hasOldPwd = this.$route.query.hasOldPwd;
        this.initValidate();

        if (this.$env.isTravelCatApp) {
            nativeApi.setRightBtn({ text: "完成" });
            nativeApi.onRightBtnClick(() => {
                this.handleSubmit();
            });
        }
    },

    computed: {},

    methods: {
        initValidate() {
            this.form = new Form({
                oldPwd: [
                    {
                        validate: value =>
                            this.hasOldPwd ? Form.required(value) : true,
                        msg: "请输入原密码"
                    }
                ],
                newPwd: [
                    { validate: Form.required, msg: "请输入密码" },
                    { validate: this.validatePwd, msg: "密码格式不正确" }
                ],
                confirmPwd: [
                    { validate: Form.required, msg: "请再次确认密码" },
                    {
                        validate: value => this.confirmPwd === value,
                        msg: "您两次输入的密码不一致"
                    }
                ]
            });
        },

        validatePwd(value) {
            // 6到12位
            return /^[\w_-]{6,12}$/.test(value);
        },

        handleSubmit() {
            let data = {
                oldPwd: this.oldPwd,
                newPwd: this.newPwd,
                confirmPwd: this.confirmPwd
            };
            let result = this.form.validate(data);
            if (result.allPass) {
                let postData = this.hasOldPwd ? this.updatePwd : this.setPwd;
                postData(data).then(res => {
                    if (+res.code === 200) {
                        this.$messageBox({
                            title: "密码设置成功",
                            type: "alert"
                        }).then(() => {
                            this.$env.isTravelCatApp
                                ? nativeApi.goBack()
                                : this.$router.go(-1);
                        });
                    } else {
                        this.$toast.open({ msg: res.msg });
                    }
                });
            } else {
                // 验证不通过，展示第一个错误
                let firstError = Form.getFirstError(result.result);
                this.$toast.open({ msg: firstError.msg });
            }
        },

        updatePwd(data) {
            return updatePassword(data);
        },

        setPwd(data) {
            let { newPwd, confirmPwd } = data;
            return setPassword({
                pwd: newPwd,
                confirmPwd
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

input {
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    // /*去除系统默认的样式*/
    -webkit-appearance: none;
    // /* 点击高亮的颜色*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.container {
    background: $baseBackgroundColor;
}

.form-item {
    height: 1.1rem;
    background: #fff;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    font-size: 0.28rem;
    display: flex;
    align-items: center;
}

.form-item-label {
    padding-left: 0.34rem;
    flex-basis: 1.6rem;
}

.form-item-input {
    flex: 1;
    display: flex;
    align-items: center;

    > input {
        flex: 1;
        height: 0.4rem;
        line-height: 0.4rem;
    }
}

.top-split-line {
    margin-top: 0.1rem;
}

.submit-btn {
    margin-top: 0.3rem;
}
</style>
